import { RootState } from 'app/store/rootReducer';

export const selectCepikData = (state: RootState) =>
  state.shortPathData.cepikData;

export const selectCepikMergeData = (state: RootState) =>
  state.shortPathData.mergeData;

export const selectIsCepikDataRejected = (state: RootState) =>
  state.shortPathData.isCepikDataRejected;

export const selectIsCepikDataRejectionModalOpened = (state: RootState) =>
  state.shortPathData.isCepikDataRejectionModalOpened;

export const selectIsCepikModalSavingInProgress = (state: RootState) =>
  state.shortPathData.isCepikModalSavingInProgress;

export const selectQuotationWithCepikData = (state: RootState) =>
  state.shortPathData.quotationWithCepikData;

export const selectLastRegistrationNumberWithReturnedData = (
  state: RootState
) => state.shortPathData.lastRegistrationNumberWithReturnedData;
